import React from 'react';
import Tag from '../../../../components/Display/Tag';
import { getImage } from '../../../../utils/imageHelper';

function PropertyItem({ property, handleClickProperty }) {
  return (
    <div
      className="flex flex-row items-start py-5 px-3 gap-x-5 cursor-pointer hover:bg-slate-100"
      onClick={handleClickProperty}>
      <img
        className="h-32 w-32 object-cover shadow-md block rounded-md"
        src={property.main_img ? property.main_img.file : getImage('img-ph.png')}
        alt={property.main_img ? property.main_img.label : 'Non renseignée'}
      />
      <div className="flex flex-col justify-between h-full">
        <div className="flex flex-col gap-y-1">
          <div className="text-xl font-bold text-slate-700 ">{property.title}</div>
          <span className="font-medium text-slate-700">
            {property.dept}, {property.surface} ha
          </span>

          <span className="font-small text-slate-700">{property.price} €</span>
        </div>
        <div className="flex flex-row gap-x-3">
          <Tag
            tag={{
              label: property.availabilty ? 'Disponible' : 'Non disponible',
              bgColor: property.availabilty ? 'bg-green-700' : 'bg-green-950'
            }}
            rounded
          />
          <Tag
            tag={{
              label: property.sold ? 'Vendu' : 'Non vendu',
              bgColor: property.sold ? 'bg-purple-700' : 'bg-purple-950'
            }}
            rounded
          />
        </div>
      </div>
    </div>
  );
}

export default PropertyItem;
